module.exports = __webpack_public_path__ + "img/28_73.47affbe3.png";